import './TextInput.scss'
import classnames from 'classnames'
import React from 'react'
import InputWrapper from './InputWrapper'

const TextInput = (props) => {
  const {
    id,
    type,
    size,
    label,
    value,
    required,
    placeholder,
    autoFocus,
    className,
    readOnly,
    onChange,
    onKeyUp
  } = props

  return (
    <InputWrapper {...props} className={classnames('TextInput', className)}>
      {({ onFocus, onBlur }) => (
        <input
          id={id}
          size={size}
          type={type}
          name={label}
          readOnly={readOnly}
          autoComplete='off'
          required={required}
          autoFocus={autoFocus}
          placeholder={placeholder}
          value={value || ''}
          onChange={e => onChange(e.target.value)}
          onKeyUp={e => onKeyUp && onKeyUp(e.target.value)}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      )}
    </InputWrapper>
  )
}

TextInput.displayName = 'TextInput'

TextInput.defaultProps = {
  type: 'text'
}

export default TextInput



// WEBPACK FOOTER //
// ./src/lib/form/TextInput.js